import { connect } from "react-redux";
import SellOrder from "./SellOrder.Component";
import * as actions from "./user.sell.order.actions";
import { get_holdings_for_depot } from "../../../services/users/depot/actions";

function mapStateToProps(state) {
  return { depot: state.depot };
}

function mapDispatchToProps(dispatch) {
  return {
    palceSellOrder: (creditId, depotId, salesFee) => {
      dispatch(actions.user_portfolio_sell(creditId, depotId, salesFee));
    },
    getHoldignsForDepot: (depotId) => {
      dispatch(get_holdings_for_depot(depotId));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SellOrder);
